function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1 4C1 2.34315 2.34315 1 4 1H26C27.6569 1 29 2.34315 29 4V29H4C2.34315 29 1 27.6569 1 26V4Z",
  fill: "white",
  stroke: "#8AB91D"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.019 11.998H20.55C21.703 11.998 23 13.152 23 15.998C23 18.844 22.91 22.998 18.19 22.998C14.6981 22.998 13.8842 22.3864 13.1708 21.8504C12.6142 21.4322 12.1189 21.06 10.461 21.06L10 20.998V12.998C10 12.998 13.47 11.828 13.704 8.063C13.704 8.063 13.667 7.002 14.983 7C15.739 6.999 16.093 8.037 16.019 9.267V11.998ZM9 20.998C9 21.55 8.552 21.998 8 21.998C7.448 21.998 7 21.55 7 20.998V13.029C7 12.477 7.448 12.029 8 12.029C8.552 12.029 9 12.477 9 13.029V20.998Z",
  fill: "#8AB91D"
});

var SvgGoodMark = function SvgGoodMark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGoodMark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/good_mark.168be112.svg";
export { ForwardRef as ReactComponent };